import {WORKSPACE_QUOTA_MIN_BYTES,WORKSPACE_QUOTA_MAX_BYTES,validWorkspaceQuotaBytes} from '@reados/contracts';

export const WORKSPACE_MIB=1024**2;

/** Text input deliberately excludes decimals, exponents and numeric coercion. */
export function workspaceQuotaBytes(input:string):number {
  const value=input.trim();
  if(!/^\d+$/.test(value))throw new Error('请输入整数 MiB，不支持小数。');
  const bytes=Number(value)*WORKSPACE_MIB;
  if(!validWorkspaceQuotaBytes(bytes))throw new Error(`空间上限须为 ${WORKSPACE_QUOTA_MIN_BYTES/WORKSPACE_MIB}–${WORKSPACE_QUOTA_MAX_BYTES/WORKSPACE_MIB} MiB（最多 1 TiB）。`);
  return bytes;
}
